import adapter from './adapter'
import { collectionGetters } from '@/store/collection'
import { paginationGetters, paginationItemsGetter } from '@/store/pagination'
import { Refund } from './model'

const { getAll, getCollection, itemGetter } = collectionGetters(adapter, {
  constructor: data => new Refund(data)
})

const { getPagination, hasMorePage, getTotalPagination } = paginationGetters()
const getPaginationRefunds = paginationItemsGetter(itemGetter)

export default {
  getAll,
  getCollection,
  getRefund: itemGetter,
  getPagination,
  hasMorePage,
  getTotalPagination,
  getPaginationRefunds,
  getResume: (state) => state.resume,
  getResumeByMonth: (state) => state.resumeByMonth,
}
